<div class="animated fadeIn">
  <div class="row sfapp-container">
    <div class="col-md-12">
      <div class="card">
        <div class="card-header">
          <span><i class="fa s-icon-list"></i> 入退館履歴一覧</span>
        </div>
        <div class="card-body">
          <div id="calendar"></div>
        </div>
      </div>
    </div>
  </div>

  <div class="modal fade" id="currentStudioModal" tabindex="-1" role="dialog" aria-labelledby="currentStudioModalLabel" aria-hidden="true">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="currentStudioModalLabel"><i class="fa s-icon-studio"></i>&nbsp;店舗情報</h5>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <div class="form-group">
            <table>
              <tr><th class="w-25">店舗名：</th><td>{{ current.name }}</td></tr>
              <tr><th>住所：</th><td>〒{{ current.zip }}</td></tr>
              <tr><th></th><td>{{ current.address }}</td></tr>
              <tr><th>電話番号：</th><td>{{ current.phone }}</td></tr>
            </table>
          </div>
        </div>
        <div class="modal-footer">
          <button class="btn bg-close text-white" type="button" data-dismiss="modal"><i class="fa s-icon-cancel"></i>&nbsp;閉じる</button>
        </div>
      </div>
    </div>
  </div>
</div>
